export default["__VITE_ASSET__CUwxBEmD__","__VITE_ASSET__SDYUysV0__"];